import { Button, Code, H1, P } from '@dnb/eufemia';
import { download } from '@dnb/eufemia/icons';
import Markdown from '@portals/shared-frontend/components/Markdown';
import { useCallback } from 'react';

import { EventSchemaResponse } from '@/openapi/schema';
import { downloadFile } from '@/utils/downloadUtils';
import { toJsonMarkdown } from '@/utils/markdownUtils';
import { capitalizeFirstLetterOfString } from '@/utils/textUtils';

import style from './index.module.css';

interface Props {
  eventSlug: string;
  schema: EventSchemaResponse;
}

export default function SchemaView({ eventSlug, schema }: Props) {
  const handleDownload = useCallback(() => {
    downloadFile(`${eventSlug}.${schema.type}-schema.json`, JSON.stringify(schema.schema, null, '\t'));
  }, [eventSlug, schema]);

  return (
    <div id={`${schema.type}-schema`}>
      <H1 bottom="small" size="x-large" top="0">
        {capitalizeFirstLetterOfString(schema.type)} Schema
      </H1>
      <div className={style['Content']}>
        <P>
          Format: <Code>{schema.format}</Code>
        </P>
        <Button icon={download} onClick={handleDownload} size="small" text="Download API reference" variant="tertiary">
          Download
        </Button>
      </div>
      <Markdown key={schema.type}>{toJsonMarkdown(JSON.stringify(schema.schema, null, '\t'))}</Markdown>
    </div>
  );
}
